// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"951d3d73","919":"4da82546","1866":"bd4c68b0","2333":"951d3d73","3432":"951d3d73","3706":"951d3d73","6365":"951d3d73","7998":"b8427898","8337":"bd4c68b0","8584":"951d3d73","8607":"43a8e09d","9952":"951d3d73"}[chunkId] + ".chunk.css";
};